 import React from 'react';
import ReservationSegmentBuilderNavigation  from './ReservationSegmentBuilderNavigation';
import ReservationSegmentBuilderAccommodations from './steps/ReservationSegmentBuilderAccommodations';
import ReservationSegmentBuilderConfirm from './steps/ReservationSegmentBuilderConfirm';
import ModalButtons from '../ModalButtons/ModalButtons';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import ModalWarning from '../ModalWarning/ModalWarning';
import ModalWarningCheckboxConfirmation from '../ModalWarning/ModalWarningCheckboxConfirmation';
import DateHelper from '../DateHelper/DateHelper';
import numeral from "numeral";
import ReactPortalsRoot from "../ReactPortalsRoot/ReactPortalsRoot";
import FixedFooter from "../admin/FixedFooter";

const _cloneDeep = require('lodash/cloneDeep');
import { format, addDays, isAfter, parseISO} from 'date-fns';
import { isEqual } from 'lodash';

export default class ReservationSegmentBuilder extends React.Component{
  constructor(props) {
    super(props)
    var card = undefined
    if (this.props.reservation_segment.incidental_deposit_card) {
      card = this.props.reservation_segment.incidental_deposit_card
    } else {
      if (this.props.reservation_segment.reservation_customer) {
        this.props.reservation_segment.reservation_customer.cards[0]
      }
    }
    this.state = {
      accept_updated_folio: true,
      displayWarningModal: false,
      overbooking_confirmation: false,
      edit_reservation_segment_folio_items_data_table_path: this.props.edit_reservation_segment_folio_items_data_table_path,
      errors: [],
      reservation_segment: this.setReservationSegment(this.props.reservation_segment),
      reservation_id: this.props.reservation_id,
      payment_log: {
        customer: this.props.reservation_segment.incidental_deposit_card_customer ? this.props.reservation_segment.incidental_deposit_card_customer : this.props.reservation_segment.reservation_customer,
        card: card,
        amount: 0,
        },
      folio: this.props.reservation_segment.folios[0],
      sendEmail: false,
      sendText: false,
      step: "accommodations",
      loading: false,
      new_folio_items: [],
      pay_now: false,
      retroactive: true,
    }
    this.onChangePayNow = this.onChangePayNow.bind(this)
    this.onChangeSendEmail = this.onChangeSendEmail.bind(this)
    this.onChangeSendText = this.onChangeSendText.bind(this)
    this.onChangeStep = this.onChangeStep.bind(this)
    this.onChangeRoom = this.onChangeRoom.bind(this)
    this.onChangeRoomGroup = this.onChangeRoomGroup.bind(this)
    this.onChangeRoomType = this.onChangeRoomType.bind(this)
    this.onChangeRate = this.onChangeRate.bind(this)
    this.onChangeDates = this.onChangeDates.bind(this)
    this.onChangeCustomer = this.onChangeCustomer.bind(this)
    this.onChangeCard = this.onChangeCard.bind(this)
    this.onChangeFolio = this.onChangeFolio.bind(this)
    this.onChangeGuestTypeCount = this.onChangeGuestTypeCount.bind(this)
    this.onChangeRetroactive = this.onChangeRetroactive.bind(this)
    this.onChangeCheckInTime = this.onChangeCheckInTime.bind(this)
    this.onChangeCheckOutTime = this.onChangeCheckOutTime.bind(this)
    this.onChangeAcceptUpdatedFolio = this.onChangeAcceptUpdatedFolio.bind(this)
    this.onChangeOverbookingConfirmation = this.onChangeOverbookingConfirmation.bind(this)

    this.save = this.save.bind(this)
  }

  render() {
    var buttons = this.setButtons()
    return(
      <div className="reservation-segment-builder">
        <ReservationSegmentBuilderNavigation  payment_log_amount={this.state.payment_log.amount} step={this.state.step} pay_now={this.state.pay_now} new_folio_items={this.state.new_folio_items} onChangeStep={this.onChangeStep} reservation_segment={this.state.reservation_segment}/>
        {this.renderStep()}
        {this.renderReservationTotal()}
        <LoadingSpinner show={this.state.loading} />
        {!this.state.displayWarningModal ?<ModalButtons loading={this.state.loading} buttons={buttons} /> : null}
        {this.state.displayWarningModal ? (
          <ReactPortalsRoot
            children={[
              <ModalWarning
                key="body"
                title={I18n.t("overbooking")}
                body={this.modalWarning(buttons)}
                CancelSubmit
                onSubmit={this.save}
                onCancel={() => this.setState({ displayWarningModal: false, overbooking_confirmation: false })}
                disabled_buttons={this.state.overbooking_confirmation ? false : true}
                // disabled_buttons={this.state.textConfirmation == false || this state.doubleTextConfirmation == false ? true : false}
                // buttons={buttons}
              />
            ]}
            wrapperClassNames="ModalWarningWrapper"
          />
        ) : null}
      </div>
    )
  }

  modalWarning(buttons) {
    return (
      <ModalWarningCheckboxConfirmation
        submit={this.onSave}
        alert_message={I18n.t('overbooking_warning_text')}
        overbooking_confirmation={this.state.overbooking_confirmation}
        onChangeOverbookingConfirmation={this.onChangeOverbookingConfirmation}
        buttons={buttons}

       />

    );
  }

  onChangeOverbookingConfirmation(e) {
    
    this.setState({overbooking_confirmation: e.target.checked})
  }

  renderStep() {
    if (this.state.step == "accommodations") {
      return <ReservationSegmentBuilderAccommodations
              errors={this.state.errors}
              daily_rental={this.props.daily_rental}
              reservation_id={this.props.reservation_id}
              reservation_segment={this.state.reservation_segment}
              retroactive={this.state.retroactive}
              original_reservation_segment={this.props.reservation_segment}
              add_charge_rates_remote_path={this.props.add_charge_rates_remote_path}
              new_folio_items={this.state.new_folio_items}
              onChangeRoom={this.onChangeRoom}
              onChangeRoomGroup={this.onChangeRoomGroup}
              onChangeRoomType={this.onChangeRoomType}
              onChangeRate={this.onChangeRate}
              onChangeDates={this.onChangeDates}
              onChangeGuestTypeCount={this.onChangeGuestTypeCount}
              onChangeRetroactive={this.onChangeRetroactive}
              onChangeCheckInTime={this.onChangeCheckInTime}
              onChangeCheckOutTime={this.onChangeCheckOutTime}
              date_format={this.props.date_format}
              time_format={this.props.time_format}
            />
    } else if (this.state.step == "confirm_and_book") {
      return ( <ReservationSegmentBuilderConfirm {...this.state} 
        edit_reservation_segment_folio_items_data_table_path={this.state.edit_reservation_segment_folio_items_data_table_path}
        date_format={this.props.date_format} 
        read_only={this.state.accept_updated_folio ? false : true}
        onChangeAcceptUpdatedFolio={this.onChangeAcceptUpdatedFolio}
      /> )
    }
  }

  renderReservationTotal() {
    if (this.state.payment_log) {
      return (
        <FixedFooter {...this.props} {...this.state} label={I18n.t('room_total_difference')} text={this.formatCurrency(this.state.payment_log.amount)} showSendEmail={true} onChangeSendEmail={this.onChangeSendEmail} showSendText={this.props.enable_messaging} onChangeSendText={this.onChangeSendText}/>
      );
    } else {
      return null;
    }
  }

  setButtons() {
    var self = this;

    if (this.state.step == "accommodations") {
      if(this.state.payment_log.amount && this.state.payment_log.amount != 0 && this.state.reservation_segment.status != "held" || this.state.new_folio_items && this.state.new_folio_items.length > 0){
        var buttons = [
          {
            name: I18n.t('cancel'),
            html_attributes: [
              'data-dismiss="modal"'
            ]
          },
          {
            name: I18n.t('next'),
            button_classes: ['primary'],
            onClick: function (e) {
              self.setState({
                step: "confirm_and_book"
              })
              return false;
            },
          },
        ]
      } else {
        var buttons = [
          {
            name: I18n.t('cancel'),
            html_attributes: [
              'data-dismiss="modal"'
            ]
          },
          {
            name: I18n.t('submit'),
            button_classes: ['primary'],
            onClick: function (e) {
              self.save()
              return false;
            },
          },
        ]
      }
    } else if (this.state.step == "confirm_and_book") {
        if (this.state.pay_now && this.state.new_folio_items && this.state.new_folio_items.length) {
          var buttons = [
            {
              name: I18n.t('prev'),
              button_classes: ['default'],
              onClick: function (e) {
                self.setState({
                  step: "accommodations"
                })
                return false;
              },
            },
            {
              name: I18n.t('submit'),
              button_classes: ['primary'],
              onClick: function (e) {
                self.save()
                return false;
              },
            },
          ]
        } else {
          var buttons = [
            {
              name: I18n.t('prev'),
              button_classes: ['default'],
              onClick: function (e) {
                self.setState({
                  step: "accommodations"
                })
                return false;
              },
            },
            {
              name: I18n.t('submit'),
              button_classes: ['primary'],
              onClick: function (e) {
                self.save()
                return false;
              },
            },
          ]
        }
      } else {
        return null;
      }

    return buttons
  }

  save() {
    var self = this;
    self.setState({loading: true})
    let folio_items = []
    if (this.state.new_folio_items && this.state.new_folio_items.length > 0) {
      folio_items = this.state.new_folio_items.map((folioItem) => JSON.stringify(folioItem));
    }
    let reservation_segment_guest_types = this.state.reservation_segment.reservation_segment_guest_types.map((rsgt) => JSON.stringify(rsgt))

    $.ajax({
      type: 'POST',
      url: this.props.reservation_segment_update_path,
      data: {
        reservation_segment: {
          room_type_id: self.state.reservation_segment.room_type ? self.state.reservation_segment.room_type.id : null,
          room_id: self.state.reservation_segment.room ? self.state.reservation_segment.room.id : null,
          room_group_id: self.state.reservation_segment.room_group ? self.state.reservation_segment.room_group.id : null,
          check_in_date: self.state.reservation_segment.check_in_date,
          check_out_date: self.state.reservation_segment.check_out_date,
          check_in_time: self.state.reservation_segment.check_in_time ? format(
            self.state.reservation_segment.check_in_time,
            DateHelper.rubyToDateFNS(this.props.time_format)
          ) : null,
          check_out_time: self.state.reservation_segment.check_out_time ? format(
            self.state.reservation_segment.check_out_time,
            DateHelper.rubyToDateFNS(this.props.time_format)
          ) : null,
          rate_id: self.state.reservation_segment.rate_id,
        },
        overbooking_confirmation: self.state.overbooking_confirmation,
        send_email: self.state.sendEmail,
        send_text: self.state.sendText,
        folio_items: folio_items,
        reservation_segment_guest_types: reservation_segment_guest_types,
        folio: self.state.folio,
        payment_log: self.state.pay_now ? self.state.payment_log : null,
      },
    }).done(function(data) {
      if (data && data.errors && data.errors.length) {
        self.setState({errors: data.errors, loading: false, step: "accommodations" })
      } else if (data && data.overbooking) {
        self.setState({displayWarningModal: true, loading: false})

      } else {
        if (parent && parent.refresh_data) {
          if (self.props.new_record == true) {
            parent.refresh_data(I18n.t('reservation_created_successfully'));
          } else {
            parent.refresh_data(I18n.t('reservation_saved_successfully'));
          }
        }

        window.parent.$(window.parent).trigger("reservationSavedSuccessfully")

        if(parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    })
  }

  onChangeCustomer(customer) {
    var self = this;

    $.ajax({
      type: 'GET',
      url: '/admin/customers/' + customer.id + '.json',
    }).done((data) => {
      if (data && data.id) {
        self.onChangePaymentCustomer(data)
      };
    });
  }

  onChangeSendEmail(e) {
    this.setState({ sendEmail: e.target.checked });
  }

  onChangeSendText(e) {
    this.setState({ sendText: e.target.checked });
  }

  onChangePaymentCustomer(cust) {
    var self = this;
    if (cust) {
      var paymentLog = Object.assign({}, self.state.payment_log)
      paymentLog.customer = cust
      this.setState({
        payment_log: paymentLog,
      })
    }
  }

  onChangeAcceptUpdatedFolio(e) {
    let segment = Object.assign({}, this.state.reservation_segment)
    segment.subtotal_amount = 0
    segment.total_amount = 0
    segment.taxes_and_fees_amount = 0
    this.setState({
      accept_updated_folio: e.target.checked,
      reservation_segment: segment,
    }, () => {
      if (e.target.checked == false) {
        this.revertPrice()
      } else {
        this.calculatePrice(segment)
      }
    })
  }

  onChangePayNow(e) {
    this.setState({
      pay_now: e,
    })
  }

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  }

  calculatePrice(reservation_segment) {
    var self = this;

    self.setState({loading: true})
      $.ajax({
        type: 'POST',
        url: '/admin/reservations/calculate-pricing',
        data: {
          reservation: {
            reservation_segments: [reservation_segment],
          },
          retroactive: self.state.retroactive,
          edit_reservation_segment: self.props.edit_segment,
          rebuild_session: true,
        },
      }).done( (data) =>{
        if (data && data.errors && data.errors.length == 0) {
          let segment = this.setReservationSegment(data.reservation_segments[0]);
          let new_folio_items = data.new_folio_items
          let total_amount = 0
          let subtotal_amount = 0
          let taxes_and_fees_amount = 0
          let payment_log_amount = 0
          if (new_folio_items && new_folio_items.length > 0) {
            new_folio_items.map((folio_item) => {
    
              payment_log_amount += folio_item.total_amount_with_children
              if (folio_item.total_amount < 0){
                total_amount += folio_item.total_amount_with_children
                subtotal_amount += folio_item.total_amount
                if (folio_item.total_amount != folio_item.total_amount_with_children) {
                  taxes_and_fees_amount += (folio_item.total_amount_with_children - folio_item.total_amount)
                }
              }
              folio_item.id = self.generateId()
            })
          } else if (this.state.reservation_segment.total_amount != segment.total_amount) {
            payment_log_amount += ( segment.total_amount - this.state.reservation_segment.total_amount )
          }

          segment.subtotal_amount += subtotal_amount
          segment.total_amount += total_amount
          segment.taxes_and_fees_amount += taxes_and_fees_amount

          let payment_log = Object.assign({}, self.state.payment_log)
          payment_log.amount = payment_log_amount

          segment.room = self.state.reservation_segment.room
          segment.room_id = self.state.reservation_segment.room_id
          segment.room_group = self.state.reservation_segment.room_group
          segment.room_group_id = self.state.reservation_segment.room_group_id
          self.setState({
            reservation_segment: segment,
            loading: false,
            new_folio_items: new_folio_items,
            payment_log: payment_log,
            edit_reservation_segment_folio_items_data_table_path: this.props.edit_reservation_segment_folio_items_data_table_path,
          })
        }
      });
  }

  revertPrice() {
    var self = this;
    self.setState({loading: true})
      $.ajax({
        type: 'POST',
        url: `/admin/reservation_segments/${self.props.reservation_segment.id}/revert-pricing`,
        data: {
          reservation_segment: self.state.reservation_segment,
        },
      }).done( (data) =>{
        if (data) {
          let segment = Object.assign({}, this.state.reservation_segment)

          segment.subtotal_amount = data.subtotal_amount
          segment.total_amount = data.total_amount
          segment.taxes_and_fees_amount = data.taxes_and_fees_amount
          var card = undefined
          if (this.props.reservation_segment.incidental_deposit_card) {
            card = this.props.reservation_segment.incidental_deposit_card
          } else {
            if (this.props.reservation_segment.reservation_customer) {
              this.props.reservation_segment.reservation_customer.cards[0]
            }
          }
          self.setState({
            reservation_segment: segment,
            loading: false,
            new_folio_items: null,
            payment_log: {
              customer: this.props.reservation_segment.incidental_deposit_card_customer ? this.props.reservation_segment.incidental_deposit_card_customer : this.props.reservation_segment.reservation_customer,
              card: card,
              amount: 0,
              }, // revert to Same as props
            edit_reservation_segment_folio_items_data_table_path: data.folio_items_data_table_path
          })
        }
      });
  }

  onChangeStep(e) {
    this.setState({
      step: e.target.dataset.step
    })
  }

  onChangeDates(check_in_date, check_out_date) {
    if (check_in_date && check_out_date) {
      if (isAfter(check_in_date, check_out_date) || isEqual(check_in_date, check_out_date)) {
        check_out_date = addDays(check_in_date, 1)
      }

      let reservation_segment = Object.assign({}, this.state.reservation_segment);
      reservation_segment.check_in_date = check_in_date;
      reservation_segment.check_out_date = check_out_date;

      this.calculatePrice(reservation_segment)
    }
  }

  onChangeRetroactive(e) {
    let reservation_segment = Object.assign({}, this.state.reservation_segment)
    this.setState({
      retroactive: e.target.checked,
    })

    this.calculatePrice(reservation_segment);
  }

  onChangeCard(card_id) {
    if (card_id) {
      let payment_log = Object.assign({}, this.state.payment_log)
      payment_log.card.id = card_id
      this.setState({
        payment_log: payment_log,
      })
    }
  }

  onChangeGuestTypeCount (event) {
    var guest_type_id = event.target.name
    var count = event.target.value
    var seg = Object.assign({}, this.state.reservation_segment)

    if (seg.reservation_segment_guest_types) {
      var found_match = false

      for (var j = 0, jlen = seg.reservation_segment_guest_types.length; j < jlen; j++) {
        if (seg.reservation_segment_guest_types[j].guest_type_id == guest_type_id) {
          found_match = true;
          seg.reservation_segment_guest_types[j].number_of_guests = count;
        }
      }

      if (!found_match) {
        seg.reservation_segment_guest_types.push({guest_type_id: guest_type_id, number_of_guests: count})
      }
    }

    this.calculatePrice(seg)
  }

  onChangeRate(rate) {
    if (rate) {
      let reservation_segment = Object.assign({}, this.state.reservation_segment)
      reservation_segment.rate_id = rate.id
      reservation_segment.rate = rate

      this.calculatePrice(reservation_segment)
    }
  }

  onChangeRoomType(room_type) {
    if (room_type) {
      let reservation_segment = Object.assign({}, this.state.reservation_segment)
      reservation_segment.room_type = room_type
      reservation_segment.rate = null
      reservation_segment.rate_id = null
      reservation_segment.room = null
      reservation_segment.room_id = null
      reservation_segment.room_group = null
      reservation_segment.room_group_id = null
      reservation_segment.room_type.element = null

      this.setState({
        reservation_segment: reservation_segment,
        retroactive: false,
      })
    }
  }

  onChangeFolio(folio) {
    if (folio) {
      this.setState({
        folio: folio,
      })
    }
  }

  onChangeRoom(room) {
    let reservation_segment = Object.assign({}, this.state.reservation_segment)
    if (!room || room && room.id === "unassigned") {
      reservation_segment.room = null
    } else {
      reservation_segment.room = room
      reservation_segment.room.element = null
    }

    this.setState({
      reservation_segment: reservation_segment
    })
  }

  onChangeRoomGroup(room_group) {
    if (room_group) {
      let reservation_segment = Object.assign({}, this.state.reservation_segment)
      if (room_group.id === "unassigned") {
        reservation_segment.room_group = null
      } else {
        reservation_segment.room_group = room_group
        reservation_segment.room_group.element = null
      }

      this.setState({
        reservation_segment: reservation_segment
      })
    }
  }

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return '-' + text;
  };

  setReservationSegment(segment) {
    var resSeg = _cloneDeep(segment);
    resSeg.check_in_date = parseISO(segment.check_in_date);
    resSeg.check_out_date = parseISO(segment.check_out_date);
    resSeg.check_in_time = DateHelper.parseDate(segment.check_in_time)
    resSeg.check_out_time = DateHelper.parseDate(segment.check_out_time)
    return resSeg;
  };

  onChangeCheckInTime(time) {
    let seg = Object.assign({}, this.state.reservation_segment)
    seg.check_in_time = time
    this.setState({
      reservation_segment: seg,
    })
  }

  onChangeCheckOutTime(time) {
    let seg = Object.assign({}, this.state.reservation_segment)
    seg.check_out_time = time
    this.setState({
      reservation_segment: seg,
    })
  }

};